// extracted by css-extract-rspack-plugin
export default {"aside":"CalculatorAside-module__aside--wUEnN","title":"CalculatorAside-module__title--KKgSI","periods":"CalculatorAside-module__periods--IEg7M"};